import { render } from "./InfoGraduate.vue?vue&type=template&id=8dd290d0&scoped=true"
import script from "./InfoGraduate.vue?vue&type=script&lang=js"
export * from "./InfoGraduate.vue?vue&type=script&lang=js"

import "./InfoGraduate.vue?vue&type=style&index=0&id=8dd290d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd290d0"]])

export default __exports__